if (!customElements.get('card-category')) {
  class CardCategory extends HTMLElement {
    constructor() {
      super();

      this.category = null;
    }

    configImage() {
      const width_strs = [`150w`, `230w`, `346w`, `422w`, `502w`];
      const src = this.category.image
        ? this.category.image.src[0]
        : ``;

      const useWidth = (str, width_str) => {
        const width = Number(width_str.split(`w`)[0]) * 2;
        const height = width;
        const end = str.split(`/`)[1];

        if (str.indexOf(`width=`) === 0) {
          return end ? `width=${width}/${end}` : `width=${width}`;
        }

        if (str.indexOf(`height=`) === 0) {
          return end ? `height=${height}/${end}` : `height=${height}`;

        }

        return str;
      };

      const srcset = src
        ? width_strs.map((width_str) => {
          const sized_image_src = src.split(`,`).map((str) => useWidth(str, width_str)).join(`,`);

          return `${sized_image_src} ${width_str}`;
        }).join(`, `)
        : ``;

      const alt = Boolean(this.category.image && this.category.image.alt)
        ? this.category.image.alt
        : this.category.title;

      return {
        srcset,
        src,
        alt,
      };
    }

    renderCategory() {
      if (!this.category) { return; }

      const categoryTemplate = document.querySelector(`[card-category-template]`).cloneNode(true);
      const image_data = this.configImage();
      const updated_category = modifyRawHTML(categoryTemplate.innerHTML, (html_string) => {
        html_string = html_string.split(`[[ img_srcset ]]`).join(image_data.srcset);
        html_string = html_string.split(`[[ img_src ]]`).join(image_data.src);
        html_string = html_string.split(`[[ img_alt ]]`).join(image_data.alt);
        html_string = html_string.split(`[[ title ]]`).join(this.category.title);
        html_string = html_string.split(`[[ url ]]`).join(`${this.category.url}`);

        return html_string;
      });

      this.innerHTML = ``;
      this.appendChild(updated_category);
    }

    setCategory(category) {
      this.category = { ...category };
      this.renderCategory();
    }

    connectedCallback() {
      this.renderCategory();
    }
  }

  customElements.define(`card-category`, CardCategory);
}